<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <div v-if="!dataReady" class="text-center">
          <waitingAlert></waitingAlert>
        </div>
        <v-container v-else fluid class="pa-4 monitor-setting">
          <v-row dense>
            <!-- ===================== LEFT: SETTINGS FORM ===================== -->
            <v-col cols="12">
              <v-card>
                <v-card-title class="py-3">
                  ตั้งค่าหน้าจอแสดงคิว
                  <v-spacer></v-spacer>
                  <v-btn small color="primary" @click="save">Save</v-btn>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pt-4 ma-4">
                  <!-- Shop -->
                  <!-- <v-subheader class="px-0">Shop</v-subheader> -->
                  <!-- <v-text-field v-model="form.shopId" dense label="shopId"></v-text-field> -->
                  <v-img
                    aspect-ratio="6"
                    contain
                    :src="filesImageShopPreview"
                  ></v-img>
                  <v-file-input
                    dense
                    accept="image/*"
                    prepend-icon="mdi-image"
                    label="โลโก้ร้าน (upload)"
                    @change="onLogoChange"
                    v-model="filesImageShop"
                  ></v-file-input>

                  <v-divider class="my-4"></v-divider>

                  <!-- Background -->
                  <v-subheader class="px-0">ตั้งค่าพื้นหลัง</v-subheader>
                  <v-row>
                    <v-col cols="4">
                      <v-switch
                        v-model="form.isBgColor"
                        inset
                        label="ใช้สีพื้นหลัง"
                      ></v-switch>
                    </v-col>
                  <v-col cols="6" v-if="form.isBgColor" class="align-center">
                    <!-- <div class="mr-2 grey--text text--darken-1" style="min-width:120px">shopBgColor</div> -->
                    <v-color-picker
                      v-model="form.shopBgColor"
                      hide-mode-switch
                      mode="hexa"
                      width="160"
                      height="140"
                      class="small-picker"
                      flat
                    />
                  </v-col>

                   <v-col cols="6"  v-else>
                      <v-img
                        aspect-ratio="6"
                        contain
                        :src="filesImageBgPreview"
                      ></v-img>
                      <v-file-input
                        dense
                        accept="image/*"
                        prepend-icon="mdi-image"
                        label="รูปภาพพื้นหลัง (upload)"
                        @change="onBgChange"
                        v-model="filesImageBg"
                      ></v-file-input>
                      <!-- <v-text-field
                        dense
                        v-model="form.shopBgImg"
                        label="shopBgImg (URL)"
                      ></v-text-field> -->
                  </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>

                  <!-- Headers -->
                  <v-subheader class="px-0">ตั้งค่าชื่อช่อง</v-subheader>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field dense v-model="form.textHeadQueue" label="ชื่อช่องหมายเลขคิว"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <div class="align-center mb-2">
                        <!-- <div class="mr-2 grey--text text--darken-1" style="min-width:120px">textHeadQueueColor</div> -->
                        <v-color-picker v-model="form.textHeadQueueColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-switch
                        v-model="form.isShowService"
                        inset
                        label="แสดงบริการ"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="form.isShowService">
                    <v-col cols="6">
                      <v-text-field dense v-model="form.textHeadService" label="ชื่อช่องบริการ"></v-text-field>
                      <p>แสดงบริการตาม : {{ form.showServiceField }}</p>
                      <v-radio-group
                        v-model="form.showServiceField"
                        mandatory
                      >
                        <v-radio
                          label="บริการ"
                          value="flowName"
                        ></v-radio>
                        <v-radio
                          label="สถานะ"
                          value="status"
                        ></v-radio>
                        <v-radio
                          label="ช่องบริการ"
                          value="servicePoint"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                      <div class="align-center">
                        <!-- <div class="mr-2 grey--text text--darken-1" style="min-width:120px">textHeadServiceColor</div> -->
                        <v-color-picker v-model="form.textHeadServiceColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="my-4"></v-divider>

                  <!-- Queue Cards (ซ้าย) -->
                  <v-subheader class="px-0">ตั้งค่าช่องแสดงคิว</v-subheader>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center mb-4">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีกรอบช่องแสดงคิว</div>
                        <v-text-field dense v-model="form.queueBgBorder" label="e.g. 1px solid #E0E0E0"></v-text-field>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div class="align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีหมายเลขคิว</div>
                        <v-color-picker v-model="form.textQueueColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีพื้นหลังหมายเลขคิว</div>
                        <v-color-picker v-model="form.queueBgColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Service Cards (กลางแถบส้ม) -->
                  <v-subheader class="px-0">ตั้งค่าช่องแสดงบริการ</v-subheader>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center mb-4">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีกรอบช่องแสดงบริการ</div>
                        <v-text-field dense v-model="form.serviceBgBorder" label="e.g. 1px solid #D17F2C"></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีบริการ</div>
                        <v-color-picker v-model="form.textServiceColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีพื้นหลังบริการ</div>
                        <v-color-picker v-model="form.serviceBgColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">สีพื้นหลังช่องแสดงคิว</div>
                        <v-color-picker v-model="form.queueServiceCardColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>

                  <!-- Waiting Boxes -->
                  <v-subheader class="px-0">ตั้งค่าคิวที่รอ</v-subheader>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:140px">สีกรอบช่องคิวที่รอ</div>
                        <v-text-field dense v-model="form.waitingBgBorder" label="e.g. 1px solid #D9C3A6"></v-text-field>
                      </div>
                      <v-switch
                        v-model="form.isShowWaiting"
                        inset
                        label="แสดงช่องคิวที่รอ"
                      ></v-switch>
                       <v-text-field v-if="!form.isShowWaiting" dense v-model="form.textWaiting" label="ชื่อช่องคิวที่รอ (TH)"></v-text-field>
                       <v-text-field v-if="!form.isShowWaiting" dense v-model="form.textWaitingEn" label="ชื่อช่องคิวที่รอ (EN)"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:140px">สีข้อความชื่อช่องคิวที่รอ</div>
                        <v-color-picker v-model="form.waitingTextHeadColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:140px">สีหมายเลขคิวที่รอ</div>
                        <v-color-picker v-model="form.waitingTextColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:140px">สีพื้นหลังช่องคิวที่รอ</div>
                        <v-color-picker v-model="form.waitingBgColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>

                    <v-col cols="4">
                      <div class="d-flex align-center mb-2">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:140px">สีข้อความ Footer</div>
                        <v-color-picker v-model="form.footerTextColor" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </div>
                    </v-col>
                  </v-row>
                  <!-- iconTicket: '',
        iconColorTicket: '',
        textFooterTicket: '',
        textFooterTicketEn: '', -->
                  <!-- Queue Ticket -->
                  <v-subheader class="px-0">ตั้งค่าปรินท์บัตรคิว</v-subheader>
                  <v-row>
                      <v-col cols="6">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">Icon</div>
                        <v-text-field dense v-model="form.iconTicket" label="e.g. mdi-ticket"></v-text-field>
                      </v-col>
                      <!-- <v-col cols="6">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">Icon Color</div>
                        <v-color-picker v-model="form.iconColorTicket" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </v-col> -->
                  </v-row>
                  <v-subheader class="px-0">ตั้งค่าความห่างตัดกระดาษ</v-subheader>
                  <v-row>
                      <v-col cols="6">
                        <!-- <div class="mr-2 grey--text text--darken-1" style="min-width:120px">ความห่างตัดกระดาษ</div> -->
                        <v-text-field dense v-model="form.cupPaper" label="ความห่างตัดกระดาษ" type="number"></v-text-field>
                      </v-col>
                      <!-- <v-col cols="6">
                        <div class="mr-2 grey--text text--darken-1" style="min-width:120px">Icon Color</div>
                        <v-color-picker v-model="form.iconColorTicket" hide-mode-switch mode="hexa" width="160" height="140" class="small-picker" flat />
                      </v-col> -->
                  </v-row>
                   <v-row>
                      <v-col cols="6">
                        <div>
                          <v-text-field
                            v-model="itemsValueTextFooterTicket"
                            label="กด Enter เพื่อเพิ่ม Footer Ticket"
                            @keyup.enter="addTextFooterTicketToArray"
                          ></v-text-field>

                          <v-chip-group column>
                            <v-chip
                              v-for="(item, i) in (form.textFooterTicket || [])"
                              :key="i"
                              close
                              @click:close="removeTextFooterTicket(i)"
                            >
                              {{ item }}
                            </v-chip>
                          </v-chip-group>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div>
                          <v-text-field
                            v-model="itemsValueTextFooterTicketEn"
                            label="กด Enter เพื่อเพิ่ม Footer Ticket En"
                            @keyup.enter="addTextFooterTicketEnToArray"
                          ></v-text-field>

                          <v-chip-group column>
                            <v-chip
                              v-for="(item, i) in (form.textFooterTicketEn || [])"
                              :key="i"
                              close
                              @click:close="removeTextFooterTicketEn(i)"
                            >
                              {{ item }}
                            </v-chip>
                          </v-chip-group>
                        </div>
                      </v-col>
                   </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-btn
              fab
              color="primary"
              dark
              fixed
              bottom
              right
              @click="scrollToTop()"
            >
              <v-icon>mdi-view-quilt-outline</v-icon>
            </v-btn>

            <!-- ===================== RIGHT: LIVE PREVIEW ===================== -->
             <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-col cols="12">
                  <v-card class="overflow-hidden" :style="previewRootStyle">
                    <!-- Top bar + Logo -->
                    <div class="d-flex align-center px-6 py-3 justify-space-between" style="background: rgba(255,255,255,0.2)">
                      <div class="d-flex align-center">
                        <v-img v-if="form.shopLogo" :src="form.shopLogo" max-width="140" contain class="mr-4"></v-img>
                        <!-- <div>
                          <div class="text-h5 font-weight-bold" :style="{color: form.textHeadQueueColor}">
                            {{ form.textHeadQueue || 'เลขคิว' }}
                          </div>
                          <div class="text-subtitle-1" :style="{color: form.textHeadServiceColor}">
                            {{ form.textHeadService || 'จำนวนลูกค้า' }}
                          </div>
                        </div> -->
                      </div>
                      <div class="grey--text text--lighten-4">{{ nowText }}</div>
                    </div>

                    <!-- Body -->
                    <v-container fluid class="py-6">
                      <v-row no-gutters>
                        <!-- Left: Queue List -->
                        <v-col cols="12" md="6" class="pr-md-4">
                          <v-sheet class="elevation-1 rounded-xl pa-4" :color="form.queueServiceCardColor">
                            <div class="rounded-xl overflow-hidden">
                              <!-- Header (อยู่ในกล่องเดียวกัน) -->
                              <v-row no-gutters class="mb-2">
                                <v-col :cols="form.isShowService ? 6 : 12" class="pr-2">
                                  <div class="rounded-lg py-3 text-center font-weight-bold"
                                      :style="leftHeaderStyle">
                                    <span :style="{ color: form.textHeadQueueColor }">
                                      {{ form.textHeadQueue || 'เลขคิว' }}
                                    </span>
                                  </div>
                                </v-col>
                                <v-col cols="6" class="pl-2" v-if="form.isShowService">
                                  <div class="rounded-lg py-3 text-center font-weight-bold"
                                      :style="rightHeaderStyle">
                                    <span :style="{ color: form.textHeadServiceColor }">
                                      {{ form.textHeadService || 'จำนวนลูกค้า' }}
                                    </span>
                                  </div>
                                </v-col>
                              </v-row>

                              <v-row dense>
                                <v-col cols="12" v-for="(q, idx) in sampleQueues" :key="'row'+idx">
                                  <v-row no-gutters class="mb-3 align-stretch">
                                    <!-- ซ้าย: code -->
                                    <v-col :cols="form.isShowService ? 6 : 12" class="pr-2">
                                      <div class="rounded-lg d-flex align-center justify-center py-3 h-100"
                                          :style="leftItemStyle">
                                        <div class="font-weight-bold" :style="queueCodeStyle">{{ q.code }}</div>
                                      </div>
                                    </v-col>

                                    <!-- ขวา: service (แสดง/ซ่อนได้) -->
                                    <v-col v-if="form.isShowService" cols="6" class="pl-2">
                                      <div class="rounded-lg d-flex align-center justify-center py-3 h-100"
                                          :style="rightItemStyle">
                                        <span class="font-weight-bold" :style="{ color: form.textServiceColor }">
                                          {{ q.sizeText }}
                                        </span>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-sheet>
                        </v-col>

                        <!-- Right: Video/Image area -->
                        <v-col cols="12" md="6" class="pl-md-4 mt-6 mt-md-0">
                          <v-sheet class="rounded-xl elevation-1 d-flex align-center justify-center" style="height: 360px; background: rgba(0,0,0,0.3)">
                            <!-- ใช้ภาพตัวอย่างแทนวิดีโอใน Preview -->
                            <v-img
                              src="https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1200&auto=format&fit=crop"
                              contain
                              max-height="100%"
                              max-width="100%"
                            />
                          </v-sheet>
                        </v-col>
                      </v-row>

                      <!-- Waiting Boxes -->
                      <v-row class="mt-6" align="stretch" v-if="form.isShowWaiting">
                        <v-col cols="12" md="4" v-for="(w,wi) in sampleWaiting" :key="'w'+wi">
                          <v-sheet class="rounded-xl elevation-2 pa-4 waiting-box" :style="waitingBoxStyle">
                            <div class="text-subtitle-1 font-weight-bold mb-2" :style="{color: form.waitingTextHeadColor}">
                              Waiting {{ w.minutes }} min
                            </div>
                            <v-row>
                              <v-col v-for="(c,ci) in w.codes" :key="'c'+wi+ci" cols="4" :style="{color: form.waitingTextColor}">
                                {{ c }}
                              </v-col>
                            </v-row>
                          </v-sheet>
                        </v-col>
                      </v-row>
                      <v-row class="mt-6" align="stretch" v-else>
                        <v-col cols="12" class="text-center grey--text text--lighten-1">
                         <v-sheet class="rounded-xl elevation-2 pa-4 waiting-box" :style="waitingBoxStyle">
                            <div class="text-subtitle-1 font-weight-bold mb-2" :style="{color: form.waitingTextHeadColor}">
                              {{ form.textWaiting || 'Next Queue' }}
                            </div>
                            <v-row>
                              <v-col v-for="(c,ci) in sampleWaiting" :key="'c'+ci" cols="12" :style="{color: form.waitingTextColor}">
                                {{ c.codes.join(', ') }}
                              </v-col>
                            </v-row>
                         </v-sheet>
                        </v-col>

                      </v-row>
                    </v-container>
                    <v-btn
                      fab
                      color="error"
                      dark
                      fixed
                      bottom
                      right
                      @click="dialogPreview = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
            </v-dialog>
          </v-row>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import waitingAlert from '../waitingAlert.vue'
export default {
  name: 'MonitorSetting',
  components: {
    waitingAlert
  },
  data () {
    return {
      dataReady: true,
      dialogPreview: false,
      filesImageShop: null,
      filesImageBg: null,
      filesImageShopPreview: this.$session.getAll().data.shopImge,
      filesImageBgPreview: null,

      // ========== ฟอร์ม mapping กับตาราง Monitor_Management ==========
      form: {
        shopId: this.$session.getAll().data.shopId,
        shopLogo: this.$session.getAll().data.shopImge,

        isShowService: true,
        isBgColor: true,
        shopBgImg: '',
        shopBgColor: '#F2E7DC',

        textHeadQueue: 'เลขคิว',
        textHeadService: 'จำนวนลูกค้า',
        textHeadQueueColor: '#d35400',
        textHeadServiceColor: '#2c3e50',

        textQueueColor: '#d35400', // สีตัวอักษรฝั่งรหัสคิว A001, B001
        textServiceColor: '#ffffff', // สีตัวอักษรฝั่ง service/จำนวนคน

        queueBgColor: '#ffffff', // สีพื้นด้านซ้าย (card ใหญ่)
        serviceBgColor: '#f2994a', // สีพื้นแถบ service (ตรงกลาง/ขวา)
        queueServiceCardColor: '#f2994a', // สีพื้นแถบ service (ตรงกลาง/ขวา)
        queueBgBorder: '1px solid #E5DCD0',
        serviceBgBorder: '1px solid #DA8B3A',

        waitingTextHeadColor: '#7f5539',
        waitingTextColor: '#5e503f',
        waitingBgColor: '#f0e1ce',
        waitingBgBorder: '1px solid #d9c3a6',
        isShowWaiting: false,
        showServiceField: 'flowName',
        textWaiting: 'Next Queue',
        textWaitingEn: 'Next Queue',
        iconTicket: '',
        // iconColorTicket: '#7f5539',
        textFooterTicket: [],
        textFooterTicketEn: [],
        cupPaper: 0,
        footerTextColor: '#000000',

        CREATE_USER: this.$session.getAll().data.userName,
        LAST_USER: this.$session.getAll().data.userName
      },

      // ========== ตัวอย่างข้อมูลแสดงใน Preview ==========
      sampleQueues: [
        { code: 'A001', sizeText: '1 ท่าน' },
        { code: 'B001', sizeText: '2 ท่าน' },
        { code: 'C001', sizeText: '3–4 ท่าน' },
        { code: 'C002', sizeText: '3–4 ท่าน' },
        { code: 'B002', sizeText: '2 ท่าน' },
        { code: 'D001', sizeText: '5 ท่านขึ้นไป' }
      ],
      sampleWaiting: [
        { minutes: 10, codes: ['A002', 'A003', 'B004', 'C003', 'B005', 'C004'] },
        { minutes: 20, codes: ['C005', 'B006', 'A004', 'A005', 'C006', 'B007'] },
        { minutes: 30, codes: ['B008', 'A006', 'C007', 'A007', 'C008', 'B009'] }
      ],
      nowText: '',
      itemsValueTextFooterTicket: '',
      itemsValueTextFooterTicketEn: ''
    }
  },
  computed: {
    leftHeaderStyle () {
      return Object.assign({}, {
        // background: this.form.queueBgColor,
        // border: this.form.queueBgBorder
      })
    },
    rightHeaderStyle () {
      return Object.assign({}, {
        // background: this.form.serviceBgColor,
        // border: this.form.serviceBgBorder
      })
    },
    leftItemStyle () {
      return Object.assign({}, {
        background: this.form.queueBgColor,
        border: this.form.queueBgBorder
      })
    },
    rightItemStyle () {
      return Object.assign({}, {
        background: this.form.serviceBgColor,
        border: this.form.serviceBgBorder
      })
    },
    queueCodeStyle () {
      return Object.assign({}, {
        color: this.form.textQueueColor,
        fontSize: '32px'
      })
    },
    // พื้นหลังรวม
    previewRootStyle () {
      const base = {
        minHeight: 'calc(100vh - 64px)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '16px',
        overflow: 'hidden'
      }

      if (this.form.isBgColor) {
        return Object.assign({}, base, { background: this.form.shopBgColor })
      }

      return Object.assign({}, base, {
        backgroundImage: this.form.shopBgImg ? `url(${this.form.shopBgImg})` : 'none',
        backgroundColor: '#000000'
      })
    },
    // style กล่องคิวรวม (bg ซ้าย)
    queueItemStyle () {
      return {
        background: this.form.queueBgColor,
        border: this.form.queueBgBorder,
        display: 'flex',
        alignItems: 'center'
      }
    },
    // style ตัวรหัสคิว
    // queueCodeStyle () {
    //   return {
    //     color: this.form.textQueueColor,
    //     fontSize: '32px'
    //   }
    // },
    // style ชิป/การ์ด service (แถบส้ม)
    serviceChipStyle () {
      return {
        background: this.form.serviceBgColor,
        border: this.form.serviceBgBorder
      }
    },
    // style กล่อง waiting
    waitingBoxStyle () {
      return {
        background: this.form.waitingBgColor,
        border: this.form.waitingBgBorder
      }
    }
  },
  async mounted () {
    await this.getData()
    this.tickNow()
    this._timer = setInterval(this.tickNow, 1000)
  },
  beforeDestroy () {
    clearInterval(this._timer)
  },
  methods: {
    addTextFooterTicketToArray () {
      const v = (this.itemsValueTextFooterTicket || '').trim()
      if (!v) return
      if (!Array.isArray(this.form.textFooterTicket)) {
        this.$set(this.form, 'textFooterTicket', [])
      }
      this.form.textFooterTicket.push(v)
      this.itemsValueTextFooterTicket = ''
    },
    removeTextFooterTicket (i) {
      this.form.textFooterTicket.splice(i, 1)
    },
    addTextFooterTicketEnToArray () {
      const v = (this.itemsValueTextFooterTicketEn || '').trim()
      if (!v) return
      if (!Array.isArray(this.form.textFooterTicketEn)) {
        this.$set(this.form, 'textFooterTicketEn', [])
      }
      this.form.textFooterTicketEn.push(v)
      this.itemsValueTextFooterTicketEn = ''
    },
    removeTextFooterTicketEn (i) {
      this.form.textFooterTicketEn.splice(i, 1)
    },
    async getData () {
      await axios
        .get(this.$DNS_IP + '/monitor_management/get?shopId=' + this.$session.getAll().data.shopId)
        .then(response => {
          console.log('response.data', response.data)

          let rs = response.data
          if (rs.status === false) {
            console.log('getData error:', rs.message)
          } else {
            this.form = Object.assign({}, this.form, rs)
            this.form.textFooterTicket = JSON.parse(rs.textFooterTicket || '[]')
            this.form.textFooterTicketEn = JSON.parse(rs.textFooterTicketEn || '[]')
            this.filesImageShopPreview = rs.shopLogo || null
            this.filesImageBgPreview = rs.shopBgImg || null
          }
        })
    },
    scrollToTop () {
      this.dialogPreview = true
    },
    tickNow () {
      const d = new Date()
      const dateStr = d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
      const timeStr = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      this.nowText = `${dateStr}  ${timeStr}`
    },
    onLogoChange (file) {
      if (!file) return
      const reader = new FileReader()
      reader.onload = e => (this.filesImageShopPreview = e.target.result)
      reader.readAsDataURL(file)
    },
    onBgChange (file) {
      if (!file) return
      const reader = new FileReader()
      reader.onload = e => (this.filesImageBgPreview = e.target.result)
      reader.readAsDataURL(file)
    },
    // ตัวอย่าง save: map ตรงกับ DB fields ที่ให้มา
    async save () {
      this.$swal({
        title: 'ต้องการ บันทึกข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.dataReady = false
          if (this.filesImageShop) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesImageShop)
            await axios
              .post(this.$DNS_IP + `/file/upload/settingPos`, params)
              .then(function (response) {
                _this.form.shopLogo = response.data
                console.log('url filesImageShop', response.data)
              })
          }
          if (this.filesImageBg) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesImageBg)
            await axios
              .post(this.$DNS_IP + `/file/upload/settingPos`, params)
              .then(function (response) {
                _this.form.shopBgImg = response.data
                console.log('url filesImageBg', response.data)
              })
          }
          // เรียก API ของคุณเอง เช่น:
          // await this.$axios.post('/api/monitor-management', this.form)
          this.form.textFooterTicket = JSON.stringify(this.form.textFooterTicket) || JSON.stringify([])
          this.form.textFooterTicketEn = JSON.stringify(this.form.textFooterTicketEn) || JSON.stringify([])
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.$DNS_IP + "/monitor_management/add",
              this.form
            )
            .then(async response => {
              await this.getData()
              this.dataReady = true
              this.$swal({
                type: 'success',
                title: 'สำเร็จ',
                text: 'บันทึกสำเร็จ'
              })
            })
          console.log('SAVE payload:', this.form)
        })
        .catch(error => {
          console.log('error function updateData : ', error)
          this.dataReady = true
        })
    }
  }
}
</script>

<style scoped>
.monitor-setting .small-picker {
  transform-origin: left top;
}
.queue-item { transition: all .15s ease; }
.queue-item:hover { transform: translateY(-1px); }
.waiting-box { min-height: 120px; }
</style>



// WEBPACK FOOTER //
// src/components/BeFood/setting_monitor.vue